import { AxiosInstance, AxiosResponse } from "axios";
import { ApiPath } from "..";
import { ApiResponse } from "../public-types";
import { IotConfigResponse, iotConfigType, IotCustomTabRequest, IotPartnerConfig, UnionIotConfigType } from "./iot-config-type";
import { CustomIotDeviceGroup } from "./iot-types";

/** RPID01. 파트너 IoT 설정 정보 조회 */
export const getIotDisplaySettingDetailAsync = async (
  axios: AxiosInstance,
  params?: { configType: UnionIotConfigType }, //
): Promise<AxiosResponse<ApiResponse<{ config: IotConfigResponse }>>> => {
  return await axios.get(ApiPath.iot.config.detail.replace("{configType}", params?.configType || iotConfigType.DISPLAY_SPACE));
};

/** RPID02. 파트너 IoT 설정 정보 저장 */
export const saveIotDisplayUseTabAsync = async (
  axios: AxiosInstance,
  params?: IotPartnerConfig,
): Promise<AxiosResponse<ApiResponse<{ config: IotConfigResponse }>>> => {
  return await axios.put(ApiPath.iot.config.detail.replace("{configType}", params?.type || iotConfigType.DISPLAY_SPACE), {
    useTabs: params?.useTabs,
  });
};

/** RPID11. 파트너 커스텀 탭 목록 페이지 조회 */
export const getIotDisplayCustomTabListAsync = async (
  axios: AxiosInstance,
  params?: { configType: UnionIotConfigType },
): Promise<AxiosResponse<ApiResponse<{ content: CustomIotDeviceGroup[] }>>> => {
  return await axios.get(ApiPath.iot.config.custom.list, { params });
};

/** RPID12. 파트너 커스텀 탭 생성 처리 */
export const addIotDisplayCustomTabAsync = async (
  axios: AxiosInstance,
  params?: IotCustomTabRequest,
): Promise<AxiosResponse<ApiResponse<{ group: CustomIotDeviceGroup }>>> => {
  return await axios.post(ApiPath.iot.config.custom.add, params);
};

/** RPID13. 파트너 커스텀 탭 수정 처리 */
export const updateIotDisplayCustomTabAsync = async (
  axios: AxiosInstance,
  params?: IotCustomTabRequest & { groupId: string },
): Promise<AxiosResponse<ApiResponse<{ group: CustomIotDeviceGroup }>>> => {
  return await axios.patch(ApiPath.iot.config.custom.edit.replace("{groupId}", params?.groupId || ""), {
    name: params?.name,
    priority: params?.priority,
  });
};

/** RPID14. 파트너 커스텀 탭 삭제 처리 */
export const deleteIotDisplayCustomTabAsync = async (
  axios: AxiosInstance,
  params?: { groupId: string },
): Promise<AxiosResponse<ApiResponse<void>>> => {
  return await axios.delete(ApiPath.iot.config.custom.delete.replace("{groupId}", params?.groupId || ""));
};

/** RPID15. 파트너 커스텀 탭 IoT 디바이스 할당 처리 */
export const assignIotDeviceToCustomTabAsync = async (
  axios: AxiosInstance,
  params?: { groupId: string; registeredDeviceIds: string[] },
): Promise<AxiosResponse<ApiResponse<{ group: CustomIotDeviceGroup }>>> => {
  return await axios.post(ApiPath.iot.config.custom.assignDevices.replace("{groupId}", params?.groupId || ""), {
    registeredDeviceIds: params?.registeredDeviceIds,
  });
};

/** RPID16. 파트너 커스텀 탭 IoT 디바이스 할당 해제 */
export const deleteCustomTabDeviceAsync = async (
  axios: AxiosInstance,
  params?: { groupId: string; registeredDeviceId: string },
): Promise<AxiosResponse<ApiResponse<{ group: CustomIotDeviceGroup }>>> => {
  return await axios.delete(
    ApiPath.iot.config.custom.assignDevices.replace("{groupId}", params?.groupId || "") + "?registeredDeviceId=" + params?.registeredDeviceId,
  );
};
